import { render, staticRenderFns } from "./custom-rate-list.html?vue&type=template&id=6be7e220&scoped=true&"
import script from "./custom-rate-list.js?vue&type=script&lang=js&"
export * from "./custom-rate-list.js?vue&type=script&lang=js&"
import style0 from "./CustomRateList.vue?vue&type=style&index=0&id=6be7e220&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6be7e220",
  null
  
)

component.options.__file = "CustomRateList.vue"
export default component.exports